/*
 * WFC - Course directory level highlight (sections/wfc-course-cards.liquid)
 * /pages/cours?niveau=N — sent by the homepage level picker — highlights the cards whose visible level
 * badge includes N (« Niveau 2 », « Niveaux 2–4 »…) and dims the others, then shows a notice above the
 * city groups. It reads the same data-wfc-level-label the analytics read, so a highlight can never
 * disagree with what the card shows. It never hides, removes or reorders a course and never touches
 * a link or its tracking. Unknown or missing ?niveau = the page stays exactly as it is.
 */
(function () {
  if (window.WFCLevelFilter) return;
  window.WFCLevelFilter = true;

  // Badges read « Niveau 2 » / « Niveaux 2–4 » in French and "Level 2" / "Levels 2–4" on /en.
  var RANGE = /(?:niveaux?|levels?)\s*(\d)(?:\s*[–—-]\s*(\d))?/i;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function levelFromUrl() {
    var match = window.location.search.match(/[?&]niveau=(\d{1,2})(?:&|$)/);
    return match ? parseInt(match[1], 10) : 0;
  }

  function rangeOf(card) {
    var link = card.querySelector('[data-wfc-level-label]');
    var label = link ? link.getAttribute('data-wfc-level-label') : '';
    var match = label ? label.match(RANGE) : null;
    if (!match) return null;
    var low = parseInt(match[1], 10);
    var high = match[2] ? parseInt(match[2], 10) : low;
    return [Math.min(low, high), Math.max(low, high)];
  }

  function levelName(notice, level) {
    var template = notice.querySelector('template[data-wfc-level-names]');
    var node = template && template.content ? template.content.querySelector('[data-level="' + level + '"]') : null;
    return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function clear(section, notice) {
    section.classList.remove('is-level-filtered');
    section.querySelectorAll('.is-level-match, .is-level-dim').forEach(function (card) {
      card.classList.remove('is-level-match', 'is-level-dim');
    });
    notice.hidden = true;
    // Drop ?niveau from the address so a reload or a shared link shows every course again.
    var kept = window.location.search
      .replace(/^\?/, '')
      .split('&')
      .filter(function (part) {
        return part && part.indexOf('niveau=') !== 0;
      });
    try {
      window.history.replaceState(
        window.history.state,
        '',
        window.location.origin + window.location.pathname + (kept.length ? '?' + kept.join('&') : '') + window.location.hash
      );
    } catch (error) {
      // The highlight is already cleared; leaving the address unchanged is harmless.
    }
  }

  function apply(notice) {
    var level = levelFromUrl();
    if (!level) return;
    var section = notice.closest('.wfc-courses');
    var name = levelName(notice, level);
    // Only the official 1–5 taxonomy is honoured; anything else leaves the page untouched.
    if (!section || !name) return;

    var count = 0;
    section.querySelectorAll('.wfc-courses__item').forEach(function (card) {
      var range = rangeOf(card);
      var match = !!range && level >= range[0] && level <= range[1];
      card.classList.toggle('is-level-match', match);
      card.classList.toggle('is-level-dim', !match);
      if (match) count += 1;
    });
    section.classList.add('is-level-filtered');

    var text = notice.querySelector('.wfc-courses__filter-text');
    var message = (count ? text.getAttribute('data-text') : text.getAttribute('data-empty')) || '';
    text.textContent = message.replace('[niveau]', name).replace('[nombre]', String(count));
    var contact = notice.querySelector('.wfc-courses__filter-contact');
    if (contact) contact.hidden = count > 0;
    notice.hidden = false;

    var reset = notice.querySelector('.wfc-courses__filter-reset');
    if (reset) {
      reset.addEventListener('click', function (event) {
        event.preventDefault();
        clear(section, notice);
      });
    }

    // Bring the highlighted list into view once, unless the visitor has already scrolled.
    window.addEventListener(
      'load',
      function () {
        if (window.scrollY > 40) return;
        notice.scrollIntoView({ block: 'start', behavior: reduce.matches ? 'auto' : 'smooth' });
      },
      { once: true }
    );
  }

  function init() {
    document.querySelectorAll('[data-wfc-level-filter]').forEach(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
